module.exports = __webpack_public_path__ + "static/media/lenka-contact.843ec9c5.png";